let endCursor = null;
let hasNextPage = false;

export function getEndCursor() {
  return endCursor;
}
export function setEndCursor(value) {
  endCursor = value;
}

export function getHasNextPage() {
  return hasNextPage;
}
export function setHasNextPage(value) {
  hasNextPage = value;
}
